import React from 'react';
import { Save } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Switch } from '@/components/ui/switch';
import { Separator } from '@/components/ui/separator';

export const SidebarSection = ({
  id,
  status,
  setStatus,
  featured,
  setFeatured,
  featurePriority,
  setFeaturePriority,
  handleSave,
}) => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardContent className="p-6 space-y-4">
        <div>
          <Label>Status</Label>
          <RadioGroup value={status} onValueChange={setStatus} className="mt-2">
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="active" id="active" />
              <Label htmlFor="active">Active</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="draft" id="draft" />
              <Label htmlFor="draft">Draft</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="hidden" id="hidden" />
              <Label htmlFor="hidden">Hidden</Label>
            </div>
          </RadioGroup>
        </div>

        <Separator />

        <div className="flex items-center justify-between">
          <Label>Featured</Label>
          <Switch checked={featured} onCheckedChange={setFeatured} />
        </div>

        {featured && (
          <div>
            <Label>Feature Priority (1-25)</Label>
            <Input
              type="number"
              min="1"
              max="25"
              value={featurePriority}
              onChange={(e) => setFeaturePriority(Math.min(25, Math.max(1, parseInt(e.target.value) || 1)))}
              className="mt-2"
              placeholder="1"
            />
            <p className="text-xs text-slate-500 mt-1">
              Lower number = higher priority (1 appears first)
            </p>
          </div>
        )}

        <Button className="w-full" onClick={handleSave}>
          <Save className="h-4 w-4 mr-2" />
          {id ? 'Update' : 'Publish'} Firm
        </Button>
      </CardContent>
    </Card>
  );
};